export const FailedState = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={'/assets/images/dashboard/errorLogsState.svg'}
        alt="Empty logs"
        width={320}
        height={320}
      />
    </div>
  )
}
